import { useRef } from "react";
import iconUpload from "../../assets/icon-upload.svg";

interface CoverUploadProps {
  coverPreview: string | null;
  onFileSelect: (file: File) => void;
}

export function CoverUpload({ coverPreview, onFileSelect }: CoverUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) onFileSelect(file);
  }

  return (
    <button
      type="button"
      onClick={() => inputRef.current?.click()}
      className="w-[358px] h-[200px] rounded-2xl border-2 border-dashed border-stroke-secondary flex items-center justify-center overflow-hidden hover:border-brand-brown transition-colors"
    >
      {coverPreview ? (
        <img
          src={coverPreview}
          alt="Cover preview"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="flex flex-col items-center gap-2 text-text-tertiary">
          <img src={iconUpload} alt="" width={24} height={24} />
          <span className="text-sm font-medium">Upload cover</span>
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png"
        onChange={handleChange}
        className="hidden"
      />
    </button>
  );
}
